import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";
import config from "configSite";

const order = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    let qr = Object.assign({}, qstr);
    qr = fx.urlQueryString(qr, false);
    return new Promise((resolve, reject) => {
      order
        .get("/order?" + qr)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  find(id) {
    return order.get("/order/" + id);
  },
  // valid(inputs) {
  //   return order.put("/order/valid", {
  //     id: inputs.id,
  //     status: inputs.status
  //   });
  // },
  addShipper(inputs) {
    return order.put("/order/add-shipper", {
      id: inputs.id,
      shipper_id: inputs.shipper_id,
      comment: inputs.comment,
      attachments: inputs.attachments
    });
  },
  addWarehouse(inputs) {
    return order.put("/order/add-warehouse", {
      id: inputs.id,
      warehouse_id: inputs.warehouse_id
    });
  },

  finishOrder(inputs) {
    return order.put("/order/finish-order", {
      id: inputs.id,
      status: inputs.status,
      type: inputs.type
    });
  },
  confirmPayment(inputs) {
    return order.put("/order/confirm-payment", {
      id: inputs.id,
      status: inputs.status
    });
  },
  getPositionByAddress(address) {
    return order.get(
      "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        address +
        "&key=" +
        config.GM_Key,
      {
        headers: "Access-Control-Request-Headers"
      }
    );
  },
  getPickedProducts(id) {
    return order.get("/order/" + id + "/pick-products");
  },
  pickProducts(id, data) {
    return order.post("/order/" + id + "/pick-products", { products: data });
  },
  pickBundle(id, data) {
    return order.post("/order/" + id + "/pick-products", { bundles: data });
  },
  pickBundle2(id, data) {
    return order.post("/order/" + id + "/pick-products", { bundle: data });
  },
  getBySub(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return order.get("/order/get_by_subscription?" + qstr);
  },

  acceptOrder(id) {
    return order.put("/order/" + id + "/accept-order");
  },
  addDelivery(id, date, slot_id) {
    return order.put("/order/" + id + "/add_delivery_slot", {
      date: date,
      time_slot_id: slot_id
    });
  },
  updateShipment(id, data) {
    return order.put("/order/" + id + "/update-shipping-address", data);
  },
  getOrderByCustomer(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return order.get(`/order/get_by_customer?` + qstr);
  },
  getOrderBundle(id) {
    return order.get(`/order/${id}/bundle-products`);
  },
  getTotalByStatus(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return order.get(`/order/count?` + qstr);
  },
  refundOrder(data) {
    return order.put("order/finish-order", data);
  }
};
